const images = {
    logo: `${process.env.PUBLIC_URL}/static/media/logo-tdc.a2e5b91b4b152b376764.jpg`,
};

export default images;
